import React, { useState } from 'react';
import { t } from './translations';

const T = {
  card:'#181d25', border:'#232b36',
  text:'#e2e8f0', soft:'#8892a4',
};

export default function SignInModal({
  show, loginPhone, setLoginPhone, loginPassword, setLoginPassword,
  onSignIn, onClose, lang
}){
  const [showPass,setShowPass]=useState(false);
  if(!show) return null;
  return(
    <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.85)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:9999,padding:20}}>
      <div style={{background:T.card,borderRadius:16,padding:24,maxWidth:400,width:'100%',border:'1px solid '+T.border}}>
        <div style={{fontSize:20,fontWeight:700,color:T.text,marginBottom:8}}>{t(lang,'welcomeBackTitle')}</div>
        <div style={{fontSize:13,color:T.soft,marginBottom:20}}>{t(lang,'signInToAccessLoads')}</div>
        <input className="inp" type="text" inputMode="email" placeholder={t(lang,'loginPhonePh')} value={loginPhone} onChange={e=>setLoginPhone(e.target.value)} onKeyDown={e=>{if(e.key==='Enter'&&loginPhone&&loginPassword) onSignIn();}}/>
        <div style={{position:'relative'}}>
          <input className="inp" type={showPass?'text':'password'} placeholder={t(lang,'passwordPh')} value={loginPassword} onChange={e=>setLoginPassword(e.target.value)} style={{paddingLeft:42}} onKeyDown={e=>{if(e.key==='Enter'&&loginPhone&&loginPassword) onSignIn();}}/>
          <button type="button" onClick={()=>setShowPass(!showPass)} style={{position:'absolute',left:10,top:14,background:'none',border:'none',cursor:'pointer',fontSize:16,padding:0,color:'#8892a4'}}>{showPass?'🙈':'👁'}</button>
        </div>
        <button className="btn ba" disabled={!loginPhone||!loginPassword} onClick={onSignIn} style={{marginTop:8}}>{t(lang,'signIn')}</button>
        <button className="btn bo" onClick={onClose}>{t(lang,'cancel')}</button>
      </div>
    </div>
  );
}